import type {
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { TransferTipRecord } from './transfer-tip.service'

interface TransferTipSearchContext {
  usedByOptions: CrudSelectOption[]
  departmentOptions: CrudSelectOption[]
  companyOptions: CrudSelectOption[]
  channelOptions: CrudSelectOption[]
  thirdPartyOptions: CrudSelectOption[]
  optionsLoading: boolean
}

const defaultTime: [Date, Date] = [
  new Date(2000, 1, 1, 0, 0, 0),
  new Date(2000, 1, 1, 23, 59, 59)
]

export function createTransferTipSearchItems(
  context: TransferTipSearchContext
): CrudSearchItem[] {
  const selectClass = 'transfer-tip-page__search-control'

  return [
    {
      label: '客户昵称',
      prop: 'nickName',
      type: 'input',
      controlClass: selectClass,
      clearable: true,
      placeholder: '请输入客户昵称'
    },
    {
      label: '使用人',
      prop: 'usedBy',
      type: 'select',
      controlClass: selectClass,
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择使用人',
      options: context.usedByOptions
    },
    {
      label: '部门',
      prop: 'groupId',
      type: 'select',
      controlClass: selectClass,
      clearable: true,
      placeholder: '请选择部门',
      options: context.departmentOptions
    },
    {
      label: '企微账号',
      prop: 'belongEmpId',
      type: 'input',
      controlClass: selectClass,
      clearable: true,
      placeholder: '请输企微账号'
    },
    {
      label: '所属主体',
      prop: 'belongCorpId',
      type: 'select',
      controlClass: selectClass,
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择主体',
      options: context.companyOptions
    },
    {
      label: '加入时间',
      prop: 'createdTime',
      type: 'dateTimeRange',
      controlClass: 'transfer-tip-page__date-control',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      defaultTime,
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间'
    },
    {
      label: '第三方',
      prop: 'thirdParty',
      type: 'select',
      controlClass: selectClass,
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择所属第三方',
      options: context.thirdPartyOptions
    },
    {
      label: '来源渠道',
      prop: 'sourceLabel',
      type: 'select',
      controlClass: selectClass,
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择来源渠道',
      options: context.channelOptions
    },
    {
      label: '接替状态',
      prop: 'takeoverStatus',
      type: 'select',
      controlClass: selectClass,
      clearable: true,
      placeholder: '请选择接替状态',
      options: [
        { label: '全部', value: '' },
        { label: '接替完毕', value: 1 },
        { label: '等待接替', value: 2 },
        { label: '客户拒绝', value: 3 },
        { label: '接替达上限', value: 4 }
      ]
    }
  ]
}

export const transferTipTableColumns: CrudTableColumn<TransferTipRecord>[] = [
  {
    prop: 'nickName',
    label: '客户昵称',
    slot: 'customer',
    minWidth: 120,
    align: 'left',
    showOverflowTooltip: true
  },
  {
    prop: 'userId',
    label: '客户UserID',
    minWidth: 160,
    showOverflowTooltip: true
  },
  {
    prop: 'belongEmpId',
    label: '所属企微账号',
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'usedBy',
    label: '使用人',
    minWidth: 100,
    showOverflowTooltip: true
  },
  {
    prop: 'groupName',
    label: '所属分组',
    minWidth: 100,
    showOverflowTooltip: true
  },
  {
    prop: 'belongCorpName',
    label: '所属主体',
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'createdTime',
    label: '再次加入时间',
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'thirdParty',
    label: '再次加入第三方',
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'sourceLabel',
    label: '再次加入来源渠道',
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'takeoverStatus',
    label: '接替状态',
    slot: 'takeoverStatus',
    minWidth: 100
  }
]
